import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SitemarkIcon() {
	return (
		<SvgIcon sx={{ height: 61, width: 100, mr: 2 }}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={1024}
				height={1024}
				viewBox="0 0 270.933 270.933"
			>
				<g
					aria-label="LQ"
					style={{
						fontSize: "19.7556px",
						fontFamily: "&quot",
						fill: "#f1f1f1",
						strokeWidth: 0.264583,
					}}
				>
					<path
						d="M10.75 36.25v5.98c0 .769.374 1.154 1.122 1.154h5.604l-1.53-1.623h-3.308v-3.509z"
						style={{
							fontWeight: 700,
							fontStretch: "condensed",
							fontFamily: "&quot",
							strokeWidth: 0.221402,
						}}
						transform="translate(-127.425 -542.354) scale(17.5248)"
					/>
					<path
						d="M11.896 33.972c-.42 0-.723.117-.912.35l1.654 1.755v-.483h4.098v.203l-.003 2.524v1.296l1.892 1.381v-5.864c0-.775-.382-1.162-1.146-1.162z"
						style={{
							fontWeight: 700,
							fontStretch: "condensed",
							fontSize: "19.7556px",
							fontFamily: "&quot",
							fill: "#f1f1f1",
							strokeWidth: 0.221402,
						}}
						transform="translate(-127.425 -542.354) scale(17.5248)"
					/>
					<path
						d="m19.21 41.34.713 2.044-1.103-.643-5.118-5.583z"
						style={{
							display: "inline",
							fill: "#d9739d",
							strokeWidth: 0.0585792,
						}}
						transform="translate(-127.425 -542.354) scale(17.5248)"
					/>
					<path
						d="M10.75 36.33v-1.296l-.531-.994 5.284 7.246z"
						style={{
							display: "inline",
							fill: "#f1f1f1",
							strokeWidth: 0.0585792,
						}}
						transform="translate(-127.425 -542.354) scale(17.5248)"
					/>
				</g>
			</svg>
		</SvgIcon>
	);
}
